import { textInputDataReducer } from 'Components/Forms/FormReducers/TextInputReducer';
import { phoneInputDataReducer } from 'Components/Forms/FormReducers/PhoneInputReducer';
import { radioInputDataReducer } from 'Components/Forms/FormReducers/RadioInputReducer';
import { selectInputDataReducer } from 'Components/Forms/FormReducers/SelectInputReducer';
import { dateInputDataReducer } from 'Components/Forms/FormReducers/DateInputReducer';
import { checkboxInputDataReducer } from 'Components/Forms/FormReducers/CheckboxInputReducer';

import { useEffect, useReducer, useState, useRef } from "react";
import { ORG_TYPES, STATUSES, TextInputObj, DEFAULT_TEXT_INPUT, FORM_ACTION_TYPES } from "Utils/constants";
import { fileInputDataReducer } from 'Components/Forms/FormReducers/FileInputReducer';


var getVarValue = function (value) {
    if (typeof value === 'function') {
        return value();
    }
    else {
        return value;
    }
};


var disabledOnTest = {
    "Edit": [],
    "Create": [],
    "View": []
};



var getDisabledOn = function (disableOnFormActionOrgTypes, currentFormActionType, orgType) {
    var display = false;
    Object.keys(disableOnFormActionOrgTypes).map(type => {
        if (type.toLowerCase() == currentFormActionType.toLowerCase()) {
            display = true;
            disableOnFormActionOrgTypes[type].forEach(oT => {
                if (oT.toLowerCase() == orgType.toLowerCase()) {
                    display = true;
                }
            });
        }
    })
    return display;
};

var getReadOnlyOn = function (readOnlyOnFormActionOrgTypes, currentFormActionType, orgType) {
    var readOnly = false;
    Object.keys(readOnlyOnFormActionOrgTypes).map(type => {
        if (type.toLowerCase() == currentFormActionType.toLowerCase()) {
            readOnly = true;
            readOnlyOnFormActionOrgTypes[type].forEach(oT => {
                if (oT.toLowerCase() == orgType.toLowerCase()) {
                    readOnly = true;
                }
            });
        }
    });
    return readOnly;
};

var getNotRequiredOnlyOn = function (requiredOnlyOnFormActionOrgTypes, currentFormActionType, orgType) {
    var required = true;
    Object.keys(requiredOnlyOnFormActionOrgTypes).map(type => {
        if (type.toLowerCase() == currentFormActionType.toLowerCase()) {
            required = false;
            requiredOnlyOnFormActionOrgTypes[type].forEach(oT => {
                if (oT.toLowerCase() == orgType.toLowerCase()) {
                    required = true;
                }
            });
        }
    });
    return required;
};

export function GetPlainTextInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, maxLength }) {
    var plainTextInputObj = {
        type: 'plain',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            maxLength: getVarValue(maxLength)
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, plainTextInputObj);
}

export function GetTextInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, maxLength }) {
    var textInputObj = {
        type: 'text',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            maxLength: getVarValue(maxLength)
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, textInputObj);
}

export function GetTextAreaInputObj ({ id, name, value, label, description, title, placeholder, rows, count, required, isInvalid, errors, isValid, successMsgs, disabled, hasCounter, readOnly, hideFieldOrgTypes, maxLength }) {
    var textInputObj = {
        type: 'textarea',
        id: id,
        name: name,
        value: value,
        count: value.substring(0,maxLength).length,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            maxLength: maxLength==null ? 2000 : maxLength,
            rows: rows,
            hasCounter: hasCounter
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, textInputObj);
}



export function GetNumberInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, maxLength, maxValue, minValue }) {
    var numberInputObj = {
        type: 'number',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            maxLength: getVarValue(maxLength),
            maxValue: getVarValue(maxValue),
            minValue: getVarValue(minValue)
        },
        validation: {
            required: getVarValue(required),
            isInvalid: getVarValue(isInvalid),
            errors: getVarValue(errors),
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, numberInputObj);
}

export function GetFileInputObj ({ fileFormats, id, name, value, label, description, title, files, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, maxLength }) {
    var fileInputObj = {
        type: 'file',
        id: id,
        acceptFormats:fileFormats,
        name: name,
        value: value,
        files: files,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            maxLength: getVarValue(maxLength)
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(fileInputDataReducer, fileInputObj);
}

export function GetPhoneInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, maxLength }) {
    var phoneInputObj = {
        type: 'tel',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            //maxLength: getVarValue(maxLength)
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(phoneInputDataReducer, phoneInputObj);
}

export function GetRadioInputObj ({ id, name, value, radioButtons, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, inline }) {
    var radioInputObj = {
        type: 'radio',
        id: id,
        name: name,
        value: value,
        radioButtons: radioButtons,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            inline: inline
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null),
        getValue: (ans) => {
            //console.log(ans);
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isChecked==true){
                    return ans[x].value;
                }
            }
            return '';
        }
    };

    return useReducer(radioInputDataReducer, radioInputObj);
}

export function GetCheckboxInputObj ({ id, name, value, checkBoxes, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, customGetDisabledOn, inline }) {
    var checkInputObj = {
        type: 'checkbox',
        id: id,
        name: name,
        value: value,
        checkBoxes: checkBoxes,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            inline: inline
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null),
        getValue: (ans) => {
            //console.log(ans);
            var checked = [];
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isChecked==true){
                    checked.push(ans[x].value);
                }
            }
            if(checked.length==0){
                return null;
            }
            else {
                return checked;
            }
            
        }
    };

    return useReducer(checkboxInputDataReducer, checkInputObj);
}


export function GetSelectInputObj ({ id, name, value, options, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes }) {
    var selectInputObj = {
        type: 'select',
        id: id,
        name: name,
        value: value,
        options: options,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null),
        getValue: (ans) => {
            //console.log(ans);
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isSelected==true){
                    return ans[x].value;
                }
            }
            return null;
        }
    };

    return useReducer(selectInputDataReducer, selectInputObj);
}

export function GetDateInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes }) {
    var dateInputObj = {
        type: 'date',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(dateInputDataReducer, dateInputObj);
}

export function GetPasswordInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes }) {
    var passwordInputObj = {
        type: 'password',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, passwordInputObj);
}


    /* 
        @Data
        public class DocumentUploadBean {

            NUMBER docId;
            NUMBER groupId;

            MultipartFile uploadFile;

            SELECT categoryId;
            SELECT ownerId;

            TEXT displayName;

            NUMBER version;
            
            TEXTAREA docDescr;

            DATE docPubDate;

            RADIO allowPubAccess; // Y/N

            CHECK roleIds;

            RADIO isDisabled;
            RADIO isOpenForComment;
            
        }
    */
export function GetDocumentPlainTextInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        /*
            
            SELECT categoryId;
            SELECT ownerId;
            */

        case 'docId':
            return GetPlainTextInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'Document ID',
                description: '',
                title: '',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
        case 'groupId':
            return GetPlainTextInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'Group ID',
                description: '',
                title: '',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
        case 'docName':
            return GetPlainTextInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'Document Name',
                description: '',
                title: '',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
        
        
    }
}

export function GetDocumentTextInputData (fieldName, fieldValue, formActionType) {
    switch (fieldName) {

        /* 
            TEXT displayName;
        */
        case 'displayName':
            return GetTextInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                label: 'Display Name',
                description: ()=> {
                    return (
                        <span>
                            {'Name should not exceed 100 characters in length.'}
                                <br></br>
                            {'Name should not have improper characters \ / : & * ? ” < > | .'}
                        </span>
                    )
                },
                title: 'Enter Display Name',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,//getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: false,//getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 200
            });
        case 'shortName':
            return GetTextInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                label: 'Short Name',
                description: null/*()=> {
                    return (
                        <span>
                            {'Name should not exceed 100 characters in length.'}
                                <br></br>
                            {'Name should not have improper characters \ / : & * ? ” < > | .'}
                        </span>
                    )
                }*/,
                title: 'Enter Short Name',
                placeholder: '',
                required: false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,//getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: false,//getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 100
            });

    }

}

export function GetDocumentSelectInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        /*
           
            SELECT categoryId;
            SELECT ownerId;
         */

        case 'ownerId':
            return GetSelectInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'Owner',
                description: '',
                title: '',
                placeholder: 'Select Document Owner',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
        case 'categoryId':
            return GetSelectInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'Category',
                description: '',
                title: '',
                placeholder: 'Select Document Category',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
        
    }
}


export function GetDocumentPhoneInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {
        /*
            
            phoneForDisplay
            faxForDisplay
            
        */
        

        
    }
}


export function GetDocumentRadioInputData (fieldName, fieldValue, orgType, formActionType) {
    switch (fieldName) {

        /*
            RADIO allowPubAccess; // Y/N
            RADIO isDisabled;
            RADIO isOpenForComment;
        */
        case "allowPubAccess":
            return GetRadioInputObj({
                id: "document_" + fieldName,
                name: "document_" + fieldName,
                value: '',
                radioButtons: [
                    {
                        id: "yes",
                        label: "Yes",
                        name: "allowPubAccess",
                        value: 'Y',
                        title: "",
                        isChecked: fieldValue=="Y" || fieldValue=="Yes" ? true : false,
                        //onChange: handleRadioChange,
                        //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                    },
                    {
                        id: "no",
                        label: "No",
                        name: "allowPubAccess",
                        value: 'N',
                        title: "",
                        isChecked: fieldValue=="N" || fieldValue=="No" ? true : false,
                        //onChange: handleRadioChange,
                        //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                    }
                ],
                label: 'Allow Public Access',
                description: '',
                title: "",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                inline: true,
                getValue: (ans) => {
                    //console.log(ans);
                    var checked = null;
                    for(var x = 0 ; x<ans.length ; x++){
                        if(ans[x].isChecked==true){
                            checked=ans[x].value;
                        }
                    }
                    
                    return checked;
                    
                    
                }
                
            });
        case "isDisabled":
            return GetRadioInputObj({
                id: "document_" + fieldName,
                name: "document_" + fieldName,
                value: '',
                radioButtons: [
                    {
                        id: "yes",
                        label: "Yes",
                        name: "isDisabled",
                        value: 'Y',
                        title: "",
                        isChecked: fieldValue=="Y" || fieldValue=="Yes" ? true : false,//dets.testOrg=="Yes" ? true : false,
                        //onChange: handleRadioChange,
                        //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                    },
                    {
                        id: "no",
                        label: "No",
                        name: "isDisabled",
                        value: 'N',
                        title: "",
                        isChecked: fieldValue=="N" || fieldValue=="No" ? true : false,//dets.testOrg=="No" ? true : false,
                        //onChange: handleRadioChange,
                        //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                    }
                ],
                label: 'Disable Document',
                description: '',
                title: "",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                inline: true
            });
        case "isOpenForComment":
            return GetRadioInputObj({
                id: "document_" + fieldName,
                name: "document_" + fieldName,
                value: '',
                radioButtons: [
                    {
                        id: "yes",
                        label: "Yes",
                        name: "isOpenForComment",
                        value: '1',
                        title: "",
                        isChecked: fieldValue=="1" ? true : false,//dets.testOrg=="Yes" ? true : false,
                        //onChange: handleRadioChange,
                        //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                    },
                    {
                        id: "no",
                        label: "No",
                        name: "isOpenForComment",
                        value: '0',
                        title: "",
                        isChecked: fieldValue=="0" ? true : false,//dets.testOrg=="No" ? true : false,
                        //onChange: handleRadioChange,
                        //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                    }
                ],
                label: 'Open for Comment',
                description: '',
                title: "",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                inline: true
            });
    }
    
}


export function GetDocumentDateInputData (fieldName, fieldValue, orgType, formActionType) {
        /*
            DATE docPubDate;
        */
    switch (fieldName) {
        case "docPubDate":
            return GetDateInputObj({
                id: "document_" + fieldName,
                name: "document_" + fieldName,
                value: fieldValue,
                label: 'Published Date',
                description: '',
                title: "",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid:false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
    }
}

var getVersionValidation = function (fieldValue) {
    var display = false;
    /*Object.keys(disableOnFormActionOrgTypes).map(type => {
        if (type.toLowerCase() == currentFormActionType.toLowerCase()) {
            display = true;
            disableOnFormActionOrgTypes[type].forEach(oT => {
                if (oT.toLowerCase() == orgType.toLowerCase()) {
                    display = true;
                }
            });
        }
    })*/

        //console.log(fieldValue);

        if(fieldValue>20){
            return {
                isInvalid: false,
                errors: []
            };
        }
        else{
            return {
                isInvalid: true,
                errors: ["test"]
            };
        }
    
};

export function GetDocumentNumberInputData (fieldName, fieldValue, versionValidation, orgType, formActionType ) {
    /*
        NUMBER docId;
        NUMBER groupId;

        NUMBER version;
    */
    
        
   
    switch (fieldName) {

        case 'version':
            return GetNumberInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                label: 'Version',
                description: '',
                title: 'Enter Document Version',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,//getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: false,//getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: null,
                maxValue: 999,
                minValue: 1
            });
        case 'displayOrder':
            return GetNumberInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                label: 'Display Order',
                description: '',
                title: null,
                placeholder: '',
                required: false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,//getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: false,//getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxValue: 999,
                minValue: 0
            
            });
        

    }
}

export function GetDocumentTextAreaInputData (fieldName, fieldValue, orgType, formActionType) {
    /*
        TEXTAREA docDescr;
    */
    switch (fieldName) {
        case 'docDescr':
            return GetTextAreaInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                label: 'Description',
                description: '',
                title: '',
                placeholder: '',
                required: false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,//getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: false,//getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 500,
                rows: 3,
                hasCounter: true,
                count: 0
            });
        
    }
}


export function GetDocumentFileInputData (fieldName, fieldValue, value, orgType, formActionType) {
    /*
        MultipartFile uploadFile;
    */
    switch (fieldName) {
        case 'uploadFile':
            return GetFileInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: value,
                files: fieldValue,
                label: 'Select File to Upload',
                description: '',
                title: 'Select File to Upload',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,/*() => {
                    //console.log(fieldValue)
                    if(fieldValue!=null && fieldValue.length>0){
                        return true;
                    }
                    else{
                        return false;
                    }
                },*///getDisabledOn({ 'View': [] }, formActionType, orgType),
                readOnly: false,//getReadOnlyOn({ 'View': [] }, formActionType, orgType),
                hideFieldOrgTypes: [],
                maxLength: 75,
                fileFormats: null//".csv, .txt, .zip, .rar, .7z, .gz"
            });
    }
}


export function GetDocumentCheckboxInputData (fieldName, fieldValue, orgType, formActionType, customGetDisabledOn) {
        /*
            CHECK roleIds;
        */
    switch (fieldName) {
       
        case 'roleIds':
            return GetCheckboxInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                checkBoxes: [
                    
                ],
                label: 'Assigned Access Role',
                description: '',
                title: '',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                inline: false
            });
        


    }
}










